// services/proveedores.ts
import api from "./api";
const envUrl = process.env.REACT_APP_API_URL;
const API_URL = "/proveedores";

export interface Proveedor {
  id: number;
  nombre: string;
  contacto?: string;
  telefono?: string;
  email?: string;
  direccion?: string;
}

export const getProveedores = async (): Promise<Proveedor[]> => {
  const response = await api.get(API_URL);
  return response.data;
};


export const crearProveedor = async (data: Partial<Proveedor>): Promise<Proveedor> => {
  const response = await api.post(API_URL, data);
  return response.data;
};

export const actualizarProveedor = async (id: number, data: Partial<Proveedor>): Promise<Proveedor> => {
  const response = await api.put(`${API_URL}/${id}`, data);
  return response.data;
};

export const eliminarProveedor = async (id: number): Promise<{ message: string }> => {
  const response = await api.delete(`${API_URL}/${id}`);
  return response.data;
};
